import { appSettings } from '@/settings/app-settings';
import { ContentTypeEnum } from '@/ux-legacy/components/common/bentoboard/Common/bento-constants';

import createHttpClient from './http-client';

const httpClient = createHttpClient(appSettings.api.ASSET_MANAGER_URL || '');

export const AddUserSharedSpaces = async (users: string[]) => {
  try {
    const response = await httpClient.get('/threads/personal-thread', {
      params: { users },
    });
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE sending message using MessageId:', error.message);
    throw error;
  }
};

export const SendMessageSharedSpace = async (
  id: string,
  body: {
    message?: string;
    contents?: string[];
    contentData?: {
      contentType: string;
      url?: [string];
      text?: string;
      source?: string;
    };
    replyTo?: string;
  },
) => {
  const response = await httpClient.post(`/shared-space/send-message/${id}`, body);
  return response.data;
};

export const sendMessageUsingMessageId = async (
  messageId: string,
  body: {
    message: string;
    contents: string[];
    contentData: {
      contentType: string;
      url: string[];
      text: string;
      source: string;
    };
  },
) => {
  try {
    const response = await httpClient.post(`/shared-space/send-thread-reply/${messageId}`, body);
    return response?.data;
  } catch (error: any) {
    console.log('ERROR WHILE send Message Using MessageId : ', error.message);
    throw error;
  }
};

export const GetMessagesShareSpace = async (
  id: string,
  params: { limit: number; offset: number; messageId?: string },
) => {
  const response = await httpClient.get(`/shared-space/get-messages/${id}`, { params });
  return response.data;
};

export const getMessagesOfThread = async (
  messageId: string,
  params: { limit: number; offset: number; order?: string },
) => {
  try {
    const response = await httpClient.get(`/shared-space/get-thread-message/${messageId}`, { params });
    return response.data;
  } catch (error: any) {
    console.log('ERROR while get thread message', error.message);
    throw error;
  }
};

export const getBusinessThreadMessage = async (
  messageId: string,
  params: { limit: number; offset: number },
) => {
  try {
    const response = await httpClient.get(`/threads/business-thread/${messageId}`, { params });
    return response.data;
  } catch (error: any) {
    console.log('ERROR while get thread message', error.message);
    throw error;
  }
};

export const getMessagesOfThreadByDate = async (
  messageId: string,
  params: { date: string; threadType: string },
) => {
  try {
    const response = await httpClient.get(`/shared-space/get-messages-by-date/${messageId}`, { params });
    return response.data;
  } catch (error: any) {
    console.log('ERROR while get thread message', error.message);
    throw error;
  }
};

export const getSharedSpaces = async (params: {
  limit: number;
  offset: number;
  users: string[];
  onlyGivenUsers?: boolean;
  oneToOne?: boolean;
  type?: string;
}) => {
  const response = await httpClient.get(`/shared-space/get-shared-spaces`, { params });
  return response.data;
};

export const getSharedSpaceById = async (id: string) => {
  const response = await httpClient.get(`/shared-space/get-shared-space/${id}`);
  return response.data;
};

export const deleteMessage = async (id: string) => {
  const response = await httpClient.delete(`/shared-space/delete-message/${id}`);
  return response.data;
};

export const broadcastMessage = async (body: {
  userIds: string[];
  message?: string;
  contents?: string[];
  shareMessage?: string;
  contentData?: {
    contentType: ContentTypeEnum;
    url?: string[];
    text?: string;
    source?: string;
  };
}) => {
  const response = await httpClient.post(`/threads/broadcast-message`, body);
  return response.data;
};

export async function forwardMessageSharedSpace(messageId: string, sharedSpaceIds: string[]) {
  const response = await httpClient.post(`/shared-space/forward-message/${messageId}`, { sharedSpaceIds });
  return response.data;
}

export async function updateMessage(
  messageId: string,
  params: {
    message?: string;
    contents?: string[];
    contentData?: {
      contentType: string;
      url?: string[];
      text?: string[];
      source?: string;
    };
    threadName?: string;
  },
) {
  const response = await httpClient.put(`/shared-space/edit-message/${messageId}`, params);
  return response.data;
}

export async function getThreadVisitors(messageId: string, params: { limit: number; offset: number }) {
  const response = await httpClient.get(`/shared-space/get-thread-visitors/${messageId}`, { params });
  return response.data;
}

// export async function updateThreadName(messageId: string, threadName: string) {
//   const response = await httpClient.put(`/shared-space/update-thread-name/${messageId}`, { threadName });
//   return response.data;
// }

// export async function updateThread(messageId: string, body: any) {
//   try {
//     const response = await httpClient.put(`/shared-space/update-thread/${messageId}`, body);
//     return response.data;
//   } catch (error: any) {
//     console.log('ERROR while updating thread ', error.message);
//     throw error;
//   }
// }

export async function updateThread(messageId: string, body: any) {
  try {
    const response = await httpClient.put(`/threads/update-thread/${messageId}`, body);
    return response.data;
  } catch (error: any) {
    console.log('ERROR while updating thread ', error.message);
    throw error;
  }
}

export async function getThreadPortals(messageId: string) {
  try {
    // const response = await httpClient.get(`/shared-space/get-thread-portals/${messageId}`);
    const response = await httpClient.get(`/threads/thread-portals/${messageId}`);
    return response?.data;
  } catch (error: any) {
    console.log('ERROR while get thread portals ', error.message);
    throw error;
  }
}

export async function sharedSpaceAddUser(sharedSpaceId: string, users: string[]) {
  const response = await httpClient.post(`/shared-space/add-user/${sharedSpaceId}`, { users });
  return response.data;
}

export async function sharedSpaceRemoveUser(sharedSpaceId: string, userId: string) {
  const response = await httpClient.post(`/shared-space/remove-user/${sharedSpaceId}`, { userId });
  return response.data;
}

export const getSharedSpaceUsers = async (id: string) => {
  const response = await httpClient.get(`/shared-space/get-shared-space-users/${id}`);
  return response.data;
};

export const checkSharedSpaceExists = async (userId: string) => {
  const response = await httpClient.get(`/user/check-if-user-connected`, { params: { userId } });
  return response.data;
};

export async function sharedSpaceCreateThread(payload: {
  userIds?: string[];
  threadName?: string;
  message?: string;
  vendorId?: string;
  startDate?: string;
  endDate?: string;
}) {
  const response = await httpClient.post(`/threads/create-thread`, payload);
  return response.data;
}

export async function generateReply(messageId: string) {
  try {
    const response = await httpClient.get(`/shared-space/generate-reply/${messageId}`);
    return response?.data;
  } catch (error: any) {
    console.log('ERROR while generate reply', error.message);
    throw error;
  }
}

export async function getSummary(messageId: string) {
  try {
    const response = await httpClient.get(`/shared-space/get-message-summary/${messageId}`);
    return response?.data;
  } catch (error: any) {
    console.log('ERROR while get message summary', error.message);
    throw error;
  }
}

export async function findSimiarMessages(params: any) {
  try {
    const response = await httpClient.get(`/shared-space/get-similar-message`, { params });
    return response?.data;
  } catch (error: any) {
    console.log('ERROR while get message summary', error.message);
    throw error;
  }
}

export async function getBusinessThreads(params: any) {
  try {
    // const response = await httpClient.get(`/shared-space/get-business-threads`, { params });
    const response = await httpClient.get(`/threads/business-threads`, { params });
    return response?.data;
  } catch (error: any) {
    console.log('Error while fetching business threads');
    throw error;
  }
}

export async function getPersonalThreads(params: any) {
  try {
    const response = await httpClient.get(`/threads/get-threads`, { params });
    return response?.data;
  } catch (error: any) {
    console.log('Error while fetching personal threads');
    throw error;
  }
}

export async function getMyCognitionThreads(params: any) {
  try {
    const response = await httpClient.get(`/threads/my-cognition-threads`, { params });
    return response?.data;
  } catch (error: any) {
    console.log('Error while fetching my cognition threads');
    throw error;
  }
}

export async function deleteBusinessMessage(id: string) {
  try {
    const response = await httpClient.delete(`/threads/delete-message/${id}`);
    return response?.data;
  } catch (error: any) {
    console.log('Error while deleting Business message');
    throw error;
  }
}

export async function getBusinessThreadById(threadId: string) {
  try {
    const response = await httpClient.get(`/shared-space/get-business-thread/${threadId}`);
    return response?.data;
  } catch (error: any) {
    console.log('Error while fetching business thread');
    throw error;
  }
}

export async function GetOtherThreads(id: string) {
  try {
    const response = await httpClient.get(`/threads/other-threads/${id}`);
    return response?.data;
  } catch (error: any) {
    console.log(`Error while fetching otherthread`);
    throw error;
  }
}

export async function getThreadsQuickInfo(id: string) {
  try {
    const response = await httpClient.get(`/threads/quick-info/${id}`);
    return response?.data;
  } catch (error: any) {
    console.log(`Error while fetching threads quick info`);
    throw error;
  }
}

export async function fetchThreadMessage(id: string, params: { limit: number; offset: number }) {
  try {
    const response = await httpClient.get(`/threads/get-thread-messages/${id}`, { params });
    return response?.data;
  } catch (error) {
    console.log('Error while fetching thread messages');
    throw error;
  }
}

export async function sendThreadMessage(threadId: string, body: any) {
  try {
    const response = await httpClient.post(`/threads/send-thread-message/${threadId}`, body);
    return response?.data;
  } catch (error) {
    console.log('Error while sending thread message');
    throw error;
  }
}

export async function inviteUsersToThread(threadId: string, body: { users: string[] }) {
  try {
    const response = await httpClient.post(`/threads/invite-users-to-thread/${threadId}`, body);
    return response?.data;
  } catch (error) {
    console.log('Error while inviting users to thread');
    throw error;
  }
}

export async function updateCustomerSupport(body: any) {
  try {
    const response = await httpClient.patch(`/messaging-system/update-customer-support`, body);
    return response?.data;
  } catch (error) {
    console.log('Error while updating customer support ');
    throw error;
  }
}

export async function fetchPersonalThreads(params: { limit: number; offset: number; query: string }) {
  try {
    const response = await httpClient.get(`/threads/spaces`, { params });
    return response?.data;
  } catch (error) {
    console.log(`Error while fetching personal threads`);
    throw error;
  }
}

export async function fecthingThreadByUser(params: {
  limit: number;
  offset: number;
  query: string;
  userIds: string[];
}) {
  try {
    const response = await httpClient.post(`/threads/get-thread-by-users`, { params });
    return response?.data;
  } catch (error) {
    console.log(`Error while fetching thread by user`);
    throw error;
  }
}

export async function fetchThreadsList(params: {
  limit: number;
  offset: number;
  type: string;
  query?: string;
  users?: string[];
}) {
  try {
    const response = await httpClient.get(`/threads/get-threads`, { params });
    return response?.data;
  } catch (error) {
    console.log(`Error while fecthing threads`);
    throw error;
  }
}

export async function handleThreadMute(threadId: string, payload: { mute: boolean }) {
  const res = await httpClient.post(`/threads/handle-thread-mute/${threadId}`, payload);
  return res.data;
}
